export const CommandHandle =
{//基于localStorage JSON存储

    hotkeyStructure: 
	{
		"md5":"",
		"name":"",
		"type":"HOTKEY",
		"content":"",
		"icon":""
	},
	macroStructure: 
	{
		"md5":"",
		"name":"",
		"type":"MACRO",
		"content":"",
		"icon":""
	},
	dksStructure: 
	{
		"md5":"",
		"name":"",
		"type":"DKS",
		"content":"",
		"icon":""
	},
	socdStructure: 
	{
		"md5":"",
		"name":"",
		"type":"SOCD",
		"content":"",
		"icon":""
	},
    mtStructure: 
	{
		"md5":"",
		"name":"",
		"type":"MT",
		"content":"",
		"icon":""
	},
	rsStructure: 
	{
		"md5":"",
		"name":"",
		"type":"RS",
		"content":"",
		"icon":""
	},
	tglStructure: 
	{
		"md5":"",
		"name":"",
		"type":"TGL",
		"content":"",
		"icon":""
	},	
	mptStructure: 
	{
		"md5":"",
		"name":"",
		"type":"MPT",
		"content":"",
		"icon":""
	},
	endStructure: 
	{
		"md5":"",
		"name":"",
		"type":"END",
		"content":"",
		"icon":""
	},
    localCommands:[],
    initCommand()
    {
        var localCommands =  localStorage.getItem('myfuns');
        if(!localCommands)
        {
            this.saveCommad();
            localCommands =  localStorage.getItem('myfuns');
        }

        this.localCommands= JSON.parse(localCommands);
    },
	getAnalysisDKSArr(dksArr,name)
	{
		dksArr = dksArr.map(function(currentValue, index, array)
        {
            if(parseInt(currentValue) == 1)
            {
              return name + (index+1);
            }

            return currentValue;
        });

		return dksArr;
	},
	getCommandForType(type)
	{
		let curCommands = [];

		for(let i in this.localCommands)
		{
			if(this.localCommands[i].type == type)
			{
				curCommands.push(this.localCommands[i]);
			}
		}

		return curCommands;
	},
    saveCommad:function()
    {
        localStorage.setItem('myfuns',JSON.stringify(this.localCommands));
    },
	findByMD5:function(md5Str)
    {
        this.initCommand();
        for(let i in this.localCommands)
        {
            if(this.localCommands[i].md5 == md5Str)
            {
                this.localCommands[i].index = i;
                return {"index":i,"item":this.localCommands[i]};
            }
        }

        return false;
    },
	delCommad:function(md5)
    {
        this.initCommand();
		let items = this.findByMD5(md5);

        this.localCommands.splice(items.index, 1);
        this.saveCommad();
        return true;
        
    },
	updateCommad:function(md5,commandObj)
    {
		this.initCommand();
		let items = this.findByMD5(md5);

		this.localCommands[items.index] = commandObj;
		this.saveCommad();

	},
	insertCommand:function(commandObj)
	{
		this.initCommand();
		this.localCommands.push(commandObj);
		this.saveCommad();
	},
	getHotKey(auxiliaryKeys,key)
	{
		return auxiliaryKeys.join("+") + "+" + key;
	}
}
